<sdc-bo-dialog
  headerTitle="Edit Upsell"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'upsell-edit-modal-' + item?.id">
  <div class="content-wrapper">
    <div class="mt-6 mb-0">
      <div class="input-line input-file-line">
        <div>
          <span><b>Add new image</b></span
          ><br />
          <span><small>(transparent png recommended)</small></span>
        </div>
        <div class="input-file-wrapper">
          <button
            [attr.data-cy]="'upsell-edit-modal-upload-image-button'"
            class="default-2"
            (click)="addfile.click()">
            Upload Image
          </button>
          @if (item.urlImage || postImage) {
            <button
              [attr.data-cy]="'upsell-edit-modal-remove-image-button'"
              class="default-2"
              style="background-color: red"
              (click)="removeImage()">
              Remove Image
            </button>
          }
          @if (!item.urlImage && !imagePreview) {
            <div class="img-empty-container">Preview</div>
          } @else {
            @if (imagePreview) {
              <img [src]="imagePreview" alt="preview" />
            } @else {
              <img [src]="item.urlImage" alt="image" />
            }
          }
          <input
            type="file"
            class="hidden"
            #addfile
            (change)="onFileChange($event)" />
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper">
    <div>
      <div class="input-line">
        <div>
          <span><b>Name</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        <div>
          <input
            type="text"
            [(ngModel)]="item.name"
            [class.invalid-input]="hashValidator.name" />
          @if (hashValidator.name) {
            <span class="text-[80%] error-color">The entry is mandatory</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Description</b> <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <textarea
            [(ngModel)]="item.description"
            [class.invalid-input]="hashValidator.description"></textarea>
          @if (hashValidator.description) {
            <span class="text-[80%] error-color">The entry is mandatory</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Buyer Type Name</b>
            <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <input
            type="text"
            [(ngModel)]="item.buyerTypeName"
            [class.invalid-input]="hashValidator.buyerTypeName" />
          @if (hashValidator.buyerTypeName) {
            <span class="text-[80%] error-color">The entry is mandatory</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Buyer Type ID</b>
            <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <input
            type="text"
            [(ngModel)]="item.buyerTypeId"
            [class.invalid-input]="hashValidator.buyerTypeId" />
          @if (hashValidator.buyerTypeId) {
            <span class="text-[80%] error-color">The entry is not valid</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Price (USD)</b> <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <input
            type="text"
            [(ngModel)]="item.price"
            [class.invalid-input]="hashValidator.price" />
          @if (hashValidator.price) {
            <span class="text-[80%] error-color">The entry is not valid</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span>
            <b>Visibility</b>
          </span>
        </div>
        <div>
          <select [(ngModel)]="item.active">
            <option value="true">On</option>
            <option value="false">Off</option>
          </select>
        </div>
      </div>
    </div>
    <div class="ms-6">
      <div class="toggle-group mt-0 mb-4 px-4 py-2">
        <div class="toggle-wrapper">
          <input
            id="select-all-events-upsell-edit"
            type="checkbox"
            [(ngModel)]="isAllEventsSelected"
            (change)="onSelectAllEventsChange($event)" />
          <label for="select-all-events-upsell-edit"> Select all events </label>
        </div>
      </div>
      <gs-event-selector
        [initialSelected]="item.events"
        [ngModel]="selectedEventIds"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onEventSelectionChange($event)"
        (selectionMeta)="onEventSelectionMeta($event)"></gs-event-selector>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button variant="primary" (onClick)="onConfirm()">
      Save & Publish
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
